"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClickStart = void 0;
function handleClickStart() {
    const playBoard = document.getElementById('play-board');
    const buttonStart = document.getElementById('start-button');
    const buttonCheck = document.getElementById('check-level-button');
    const buttonAutoComplete = document.getElementById('auto-complete-button');
    const game = document.getElementById('game');
    buttonStart.classList.add('start-button-invisible');
    buttonCheck.classList.add('check-level-button-visible');
    buttonAutoComplete.classList.add('auto-complete-button-visible');
    game.style.position = 'static';
    game.id = 'game-start';
    playBoard.style.position = 'static';
}
exports.handleClickStart = handleClickStart;
